import { render, staticRenderFns } from "./customInfo.vue?vue&type=template&id=bfe50096&scoped=true&"
import script from "./customInfo.vue?vue&type=script&lang=js&"
export * from "./customInfo.vue?vue&type=script&lang=js&"
import style0 from "./customInfo.vue?vue&type=style&index=0&id=bfe50096&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe50096",
  null
  
)

export default component.exports